export const formatDisplayValue = (value: number) => value.toFixed(1);
